var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosePurple({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 2.04375L18.9563 0.25L10.5 8.70625L2.04375 0.25L0.25 2.04375L8.70625 10.5L0.25 18.9563L2.04375 20.75L10.5 12.2937L18.9563 20.75L20.75 18.9563L12.2937 10.5L20.75 2.04375Z",
    fill: "#491F69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosePurple);
export default __webpack_public_path__ + "static/media/ClosePurple.aefffaf9d070eab59f583e05bc396e32.svg";
export { ForwardRef as ReactComponent };